import { Input } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import styles from "../../molecules/ai-tutor/Assistant/assistant.module.css";
import AssistantImg from "../../../assets/ai-tutor/assistant.svg";
import "./Fib.css?__remix_sideEffect__";
import { renderContent } from "../../../utils/TutorConstants";
import { IoMdInformationCircle } from "react-icons/io";
import { handleCopyClick } from "../../../utils/TutorConstants";
import { useCustomToast } from "../../molecules/ai-tutor/useCustomToast";

export const Fib = (props) => {
  const showToast = useCustomToast();

  const [selectedValueWithIndex, setSelectedValueWithIndex] = useState([]);
  const [outputValue, setOutputValue] = useState([]);
  const [answerSubmitted, setAnswerSubmitted] = useState(props?.isDisabled);
  const [question, setQuestion] = useState([]);

  const handleInputChange = (index, outputData) => {
    // alert(index + "_" + value);
    var item = { key: index, val: outputData };
    const updatedArray = selectedValueWithIndex.map((prevItem) =>
    prevItem.key === item.key ? item : prevItem
    );
    // If the key doesn't exist, add the new item
    if (!selectedValueWithIndex.some((prevItem) => prevItem.key === item.key)) {
      updatedArray.push(item);
    }
    setSelectedValueWithIndex(updatedArray);

    let outputArray = updatedArray.
    sort((a, b) => a.key - b.key).
    map((obj) => obj.val);
    setOutputValue(outputArray);
    props.handleAnswerChange({ selectedItem: outputArray });
  };

  useEffect(() => {
    const regex = /(____+)/g; // Match sequences of four or more underscores
    let questionSegments = props.question.split(regex);
    const processedSegments = questionSegments.map((segment, index) => {
      if (segment.match(regex)) {
        return "____"; // Replace all matched sequences with "____", or use a more unique placeholder if necessary
      }
      return segment;
    });
    setQuestion(processedSegments);
  }, [props.question]); // Add props.question to dependencies if the question prop might change

  useEffect(() => {
    props.handleAnswerChange({
      selectedItem: outputValue
    });
  }, [props.onAnswerSubmitted]);

  return (
    <div id="fib-wrapper" className="topContainer">
      <img
        data-testid="fib-assistant-img"
        className={styles["assistant-img"]}
        src={AssistantImg}
        alt="assistant" />

      {/* <div className="question-div">
         {question.map((item, index) =>
           item.includes("_") && item.split("_").length - 1 > 3 ? (
             <Input
               isDisabled={props.onAnswerSubmitted}
               borderColor="#8F82D7"
               key={index}
               marginRight="10px"
               focusBorderColor="#8F82D7"
               variant="outline"
               onChange={(e) => {
                 handleInputChange(index, e.target.value);
               }}
             />
           ) : (
             <div key={index} className="assistant-text-fib">
               {item}
             </div>
           )
         )}
        </div> */}
      <div id="fib-question-container" className="question-div extra-styles">
        {question.map((item, index) =>
        <div
          id={`fib-segment-${index}`}>

            {item === "____" ?
          <Input
            data-testid={`fib-input-${index}`}
            w={["90%", "90%", 36]}
            isDisabled={props.onAnswerSubmitted}
            borderColor="#8F82D7"
            focusBorderColor="#8F82D7"
            variant="outline"
            ml={3}
            mr={3}
            onChange={(e) => handleInputChange(index, e.target.value)}
            pointerEvents={props?.isDontAllow ? "none" : ""} /> :


          <span id={`fib-text-${index}`}>{renderContent(item)}</span>
          }
          </div>
        )}
        {props?.allowToCopy &&
        <IoMdInformationCircle
          data-testid="fib-copy-button"
          size={18}
          className={styles["eye"]}
          onClick={() => {
            handleCopyClick(props?.currentQuestion?.uuid);
            showToast({
              description: "Question ID copied to clipboard",
              duration: 1000
            });
          }} />

        }
      </div>
    </div>);

};